import { axiosBeelineRequest } from '@beef/utils';
import { ORDER_TARIFF_ENDPOINTS } from '@fttb/common/constants';
export var fetchInitData = function fetchInitData() {
  return axiosBeelineRequest({
    url: ORDER_TARIFF_ENDPOINTS.get_init_data
  });
};